import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WarehouseTransfers_ds_get_material_by_materialIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialId: number, vendorlotId?: number, lotId?: number }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, ProjectId?: number, StandardCost?: number, StandardPrice?: number, PackagingLookups?: { PackagingId?: number, BasePackagingId?: number, BasePackagingQuantity?: number }[], Lots?: { Id?: number, TypeId?: number, VendorLotId?: number }[], VendorLots?: { Id?: number, LookupCode?: string }[] } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WarehouseTransfers/datasources/ds_get_material_by_materialId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      materialId: number, vendorlotId?: number, lotId?: number    }) {
        if(isNil(inParams.materialId)) {
          return true; 
        }
      return false;
    }
}
